export default __webpack_public_path__ + "static/media/7minfitness@3x.53913a4a.jpg";